<template>
  <component :is="iconComponent" :size="Number(size)" />
</template>

<script>
// all icon that you need
import MapIcon from 'vue-material-design-icons/Map.vue';
import TableIcon from 'vue-material-design-icons/Table.vue';
import BookAccountIcon from 'vue-material-design-icons/BookAccount.vue';
import PollIcon from 'vue-material-design-icons/Poll.vue';
import HandHeartIcon from 'vue-material-design-icons/HandHeart.vue';
import AccountIcon from 'vue-material-design-icons/Account.vue';
import MenuIcon from 'vue-material-design-icons/Menu.vue';
import DoctorIcon from 'vue-material-design-icons/Doctor.vue';
import NeedleIcon from 'vue-material-design-icons/Needle.vue';
import LogoutIcon from 'vue-material-design-icons/Logout.vue';
import LabelIcon from 'vue-material-design-icons/Label.vue';
import CheckCircleIcon from 'vue-material-design-icons/CheckCircle.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';
import MenuUpIcon from 'vue-material-design-icons/MenuUp.vue';
import CrosshairsGpsIcon from 'vue-material-design-icons/CrosshairsGps.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import WhatsappIcon from 'vue-material-design-icons/Whatsapp.vue';
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import ArrowUpIcon from 'vue-material-design-icons/ArrowUp.vue';
import ArrowDownIcon from 'vue-material-design-icons/ArrowDown.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import HandshakeIcon from 'vue-material-design-icons/Handshake.vue';
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';
import InformationIcon from 'vue-material-design-icons/Information.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import TrashCanIcon from 'vue-material-design-icons/TrashCan.vue';
import FacebookCircleIcon from 'vue-material-design-icons/Facebook.vue';
import FacebookIcon from '@/components/UI/icons/Facebook.vue';
import GoogleColoredIcon from '@/components/UI/icons/Google.vue';
import GoogleIcon from 'vue-material-design-icons/Google.vue';
import GasCylinderIcon from 'vue-material-design-icons/GasCylinder.vue';

export default {
  components: {
    MapIcon,
    TableIcon,
    BookAccountIcon,
    PollIcon,
    HandHeartIcon,
    AccountIcon,
    MenuIcon,
    DoctorIcon,
    NeedleIcon,
    LogoutIcon,
    LabelIcon,
    CheckCircleIcon,
    MenuDownIcon,
    MenuUpIcon,
    CrosshairsGpsIcon,
    CheckIcon,
    WhatsappIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ArrowUpIcon,
    ArrowDownIcon,
    CloseCircleIcon,
    MagnifyIcon,
    HandshakeIcon,
    AlertCircleIcon,
    InformationIcon,
    PlusIcon,
    TrashCanIcon,
    FacebookCircleIcon,
    FacebookIcon,
    GoogleColoredIcon,
    GoogleIcon,
    GasCylinderIcon,
  },
  props: {
    icon: [String, Array],
    size: [Number, String],
    customClass: String,
  },
  computed: {
    iconComponent() {
      return `${this.icon[1]}Icon`;
    },
  },
};
</script>
<style>
.icon svg {
  top: 0.125em;
  position: relative;
}
</style>
